import { Message } from '../types/copilot';

type StartArgs = {
  system?: string;
  messages: Message[];
  tools?: string[]; // names
  onDelta: (data: any) => void;
};

export function startCopilotStream({ system, messages, tools, onDelta }: StartArgs) {
  const controller = new AbortController();
  const token = localStorage.getItem('token');

  const body = JSON.stringify({ system, messages, tools });

  fetch('/api/copilot/stream', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body,
    signal: controller.signal,
  }).then(async (res) => {
    if (!res.body) return;
    const reader = res.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = '';
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      let idx;
      while ((idx = buffer.indexOf('\n\n')) !== -1) {
        const raw = buffer.slice(0, idx).trim();
        buffer = buffer.slice(idx + 2);
        if (!raw) continue;
        const line = raw.startsWith('data:') ? raw.slice(5).trim() : raw;
        try {
          const json = JSON.parse(line);
          onDelta(json);
        } catch {
          // ignore malformed chunk
        }
      }
    }
  }).catch(() => {/* aborted or network error */});

  return { abort: () => controller.abort() };
}

